import React, { useState } from 'react';
import { BiLoaderAlt } from 'react-icons/bi';
import useApi from '../../hooks/useApi';
import { CATEGORIES, DATE_FORMAT_DISPLAY, ROLE_AGENCY, ROLE_INFLUENCER } from '../../constants';
import { error_alert, success_alert, customStringify } from '../../utils';
import { FormattedMessage, useIntl } from 'react-intl';
import { network_tl } from '../../translations';
import { useNavigate } from 'react-router-dom';
import { DateTime } from 'luxon';
import { FaInstagram, FaTiktok } from 'react-icons/fa6';
import { IoClose } from 'react-icons/io5';
import FormattedCurrency from '../../components/FormattedCurrency';

const FormContainer = ({ formData, setStep }) => {
  console.log("formData", formData);
  const { Axios } = useApi();
  const intl = useIntl();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const handleSubmit = async () => {
    let payload = {};

    if (formData.role === ROLE_AGENCY.value) {
      payload = {
        name: formData.name,
        email: formData.email,
        sur_name: formData.sur_name,
        city: formData.city,
        address: formData.address,
        place_id: formData.place_id,
        country: formData.country,
        role: formData.role,
        agency_data: {
          company_name: formData.company_name,
          type: formData.type.value,
          contact_number: formData.contact_number,
          tax_code: formData.tax_code,
        },
      };
    } else if (formData.role === ROLE_INFLUENCER.value) {
      payload = {
        name: formData.name,
        email: formData.email,
        sur_name: formData.sur_name,
        city: formData.city,
        address: formData.address,
        place_id: formData.place_id,
        country: formData.country,
        role: formData.role,
        influencer_data: {
          gender: formData.gender ? formData.gender.value : "",
          average_price: formData.average_price ? formData.average_price : "",
          niches: formData.niches.map((item) => item.value),
          instagram_name: formData.selectedPlatforms?.includes('instagram') && formData.instagram_name ? formData.instagram_name : null,
          instagram_bio: formData.selectedPlatforms?.includes('instagram') && formData.instagram_bio ? formData.instagram_bio : null,
          instagram_followers: formData.selectedPlatforms?.includes('instagram') && formData.instagram_followers ? formData.instagram_followers : null,
          instagram_engagement_metrics: formData.selectedPlatforms?.includes('instagram') && formData.instagram_engagement_metrics ? formData.instagram_engagement_metrics : null,
          tiktok_name: formData.selectedPlatforms?.includes('tiktok') && formData.tiktok_name ? formData.tiktok_name : null,
          tiktok_followers: formData.selectedPlatforms?.includes('tiktok') && formData.tiktok_followers ? formData.tiktok_followers : null,
          tiktok_engagement_metrics: formData.selectedPlatforms?.includes('tiktok') && formData.tiktok_engagement_metrics ? formData.tiktok_engagement_metrics : null,
          date_of_birth: formData.date_of_birth,
        },
      };
    }

    console.log("Initial payload: ", payload);

    try {
      setLoading(true);
      setError(null);
      let response = {};
      if (formData.picture) {
        const PictureForm = new FormData();
        PictureForm.append("image", formData.picture);
        response = await Axios.post(`api/user/upload-image`, PictureForm);

        if (response.data?.payload) {
          payload.picture = response.data?.payload?.file_path;
        }
      }
      const result = await Axios.post(`api/user/invite-user`, payload);
      success_alert(result.data.description);
      // navigate(`/set-password/${result.data.payload.token}`);
      setLoading(false);
      setStep(3);
    } catch (e) {
      if (e.response) {
        setError(customStringify(e.response.data.description));
      } else {
        setError(network_tl(intl));
      }
      setLoading(false);
    }

  };

  return (
    <>
      <h1 className='text-3xl font-bold text-t-light'><FormattedMessage id='confirmation' defaultMessage={"Confirmation"} /></h1>

      <div className="mt-5 space-y-4 w-full mb-4">
        {/* Personal Information */}
        <div className='w-full flex flex-col md:flex-row h-full items-center md:items-stretch gap-4'>
          {formData.picture && (

            <img
              src={typeof formData.picture === 'string' ? formData.picture : URL.createObjectURL(formData.picture)}
              alt="Profile"
              className={`${formData.role === ROLE_INFLUENCER.value ? 'w-[200px] h-[200px] md:h-auto' : 'w-[165px] h-[165px] md:h-auto'} rounded-xl object-cover border`}
            />

          )}
          <div className="bg-gray-100 p-4 rounded-xl w-full">
            <h2 className="text-xl font-semibold mb-2"><FormattedMessage id='personal_information' defaultMessage={"Personal Information"} /></h2>
            <p><strong><FormattedMessage id='name' defaultMessage={"Name"} />:</strong> {formData.name}</p>
            <p><strong><FormattedMessage id='surname' defaultMessage={"Surname"} />:</strong> {formData.sur_name}</p>
            {
              formData.role === ROLE_INFLUENCER.value &&
              <div className='flex flex-col'><p className=''><strong><FormattedMessage id='gender' defaultMessage={"Surname"} />:</strong> {formData?.gender?.label}</p>
              {/* <p className=''><strong><FormattedMessage id='average_price' defaultMessage={"Surname"} />:</strong> {formData?.average_price}</p> */}
              </div>
            }
            <p><strong><FormattedMessage id='email' defaultMessage={"Email"} />:</strong> {formData.email}</p>
            {/* <p><strong><FormattedMessage id='city' defaultMessage={"City"} />:</strong> {formData.city}</p> */}
            <p><strong><FormattedMessage id='address' defaultMessage={"Address"} />:</strong> {formData.address}</p>
            {
              formData.role === ROLE_INFLUENCER.value &&
              <><p><strong><FormattedMessage id='date_of_birth' defaultMessage={"Date of Birth"} />:</strong> {DateTime.fromISO(formData.date_of_birth).toLocaleString(DATE_FORMAT_DISPLAY)}</p>
                <p><strong><FormattedMessage id='niches' defaultMessage={"Niches"} />: </strong>
                  {CATEGORIES.filter((category) =>
                    formData?.niches?.some((niche) => niche.value === category.value)
                  )
                    .map((category) => intl.formatMessage({ id: category.value, defaultMessage: category.label }))
                    .join(", ")}

                </p></>
            }
          </div>
        </div>

        {/* Role-Specific Information */}
        {formData.role === ROLE_AGENCY.value ? (
          <div className="bg-gray-100 p-4 rounded-xl w-full">
            <h2 className="text-xl font-semibold mb-2"><FormattedMessage id='agency' defaultMessage={"Agency"} /></h2>
            <p><strong><FormattedMessage id='company_name' defaultMessage={"Company Name"} />:</strong> {formData.company_name}</p>
            <p><strong><FormattedMessage id='type' defaultMessage={"Type"} />:</strong> {formData.type?.label}</p>
            <p><strong><FormattedMessage id='contact_number' defaultMessage={"Contact Number"} />:</strong> {formData.contact_number}</p>
            <p><strong><FormattedMessage id='tax_code' defaultMessage={"Tax Code"} />:</strong> {formData.tax_code}</p>
          </div>
        ) : (
          <div className="bg-gray-100 p-4 rounded-lg min-w-full">
            <h2 className="text-xl font-semibold mb-2"><FormattedMessage id='platforms' defaultMessage={"Platforms"} /></h2>
            <div className='grid  grid-cols-1 sm:grid-cols-2 gap-4'>
              {formData.selectedPlatforms?.includes('instagram') && (
                <div>
                  <div className='flex gap-x-2 items-center'>
                    <FaInstagram className="text-pink-500" size={26} />
                    <FormattedMessage id="instagram" defaultMessage={"Instagram"} />
                  </div>
                  <p><strong><FormattedMessage id='name' defaultMessage={"Name"} />:</strong> {formData.instagram_name}</p>
                  <p><strong><FormattedMessage id='followers' defaultMessage={"Followers"} />:</strong> <FormattedCurrency value={formData.instagram_followers} notCurrency /></p>
                  <p><strong><FormattedMessage id='engagement_rate' defaultMessage={"Engagement Rate"} />:</strong> {formData.instagram_engagement_metrics}</p>
                  <p className='text-wrap'><strong><FormattedMessage id='bio' defaultMessage={"Bio"} />:</strong> {formData.instagram_bio}</p>
                </div>
              )}
              {formData.selectedPlatforms?.includes('tiktok') && (
                <div>
                  <div className='flex gap-x-2 items-center'>
                    <FaTiktok className="text-black" size={26} />
                    <FormattedMessage id="tiktok" defaultMessage={"Tiktok"} />
                  </div>
                  <p><strong><FormattedMessage id='name' defaultMessage={"Name"} />:</strong> {formData.tiktok_name}</p>
                  <p><strong><FormattedMessage id='followers' defaultMessage={"Followers"} />:</strong> <FormattedCurrency value={formData.tiktok_followers} notCurrency /></p>
                  <p><strong><FormattedMessage id='engagement_rate' defaultMessage={"Engagement Rate"} />:</strong> {formData.tiktok_engagement_metrics}</p>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Profile Picture */}


      </div>


      <div>
      {error && (
        <div className="border-red-500 text-sm text-red-500 border p-5 relative bg-red-50 shadow-bottom rounded-lg min-w-full" >
          {error}
          <div onClick={() => setError(false)} className='absolute top-3 right-3 cursor-pointer'>
                <IoClose className='text-md text-red-500' />
              </div>
        </div>
      )}
      </div>

      {/* Submit Button */}
      <button
        onClick={handleSubmit}
        disabled={loading}
        className="block w-full btn btn-primary mt-4"
      >
        <p>
          {loading ? (
            <BiLoaderAlt className="animate-spin text-white text-2xl mx-auto" />
          ) : (
            <div className="flex space-x-2 justify-center items-center">
              <span className='hidden md:block'><FormattedMessage id='submit_md' defaultMessage={"I Confirm my Information, Please Submit"} /></span>
              <span className='md:hidden'><FormattedMessage id='submit' defaultMessage={"Submit"} /></span>
            </div>
          )}
        </p>
      </button>
    </>
  );
};

export default FormContainer;